/**
 * Development-only logger utility
 * All logs are automatically suppressed in production
 */

const getLogLevel = () => {
  try {
    const config = useRuntimeConfig();
    return config.public?.LOG_LEVEL || "info";
  } catch {
    return process.env.LOG_LEVEL || (process.env.NODE_ENV === "production" ? "error" : "debug");
  }
};

const shouldLog = (level: string) => {
  const currentLevel = getLogLevel();
  const levels = ["debug", "info", "warn", "error"];
  const currentIdx = levels.indexOf(currentLevel);
  const targetIdx = levels.indexOf(level);
  return targetIdx >= currentIdx;
};

export const logger = {
  log: (...args: any[]) => {
    if (shouldLog("debug")) {
      console.log(...args);
    }
  },

  error: (...args: any[]) => {
    if (shouldLog("error")) {
      console.error(...args);
    }
  },

  warn: (...args: any[]) => {
    if (shouldLog("warn")) {
      console.warn(...args);
    }
  },

  info: (...args: any[]) => {
    if (shouldLog("info")) {
      console.info(...args);
    }
  },

  debug: (...args: any[]) => {
    if (shouldLog("debug")) {
      console.debug(...args);
    }
  },
};
